import apiClient from '@/lib/api/apiClient'
import { API_ENDPOINTS } from '@/lib/api/config'
import { isImpersonating } from '@/lib/utils/storage'
import type { CsatExperienceType } from '../constants/csatConstants'

type CsatEligibilityResponse = {
  show_popup?: boolean
}

export async function fetchCsatShowPopup(params: {
  experience: CsatExperienceType
  fk_applicant_id?: string | number
  fk_reimbursement_id?: string | number
}): Promise<boolean> {
  if (isImpersonating()) {
    return false
  }
  try {
    const response = await apiClient.get<CsatEligibilityResponse>(API_ENDPOINTS.CSAT, { params })
    return Boolean(response.data?.show_popup)
  } catch {
    return false
  }
}

type CsatWritePayload = {
  experience: CsatExperienceType
  fk_applicant_id?: string | number
  fk_reimbursement_id?: string | number
}

export async function submitCsatResponse(
  payload: CsatWritePayload & { score: number },
): Promise<void> {
  if (isImpersonating()) {
    return
  }
  await apiClient.post(API_ENDPOINTS.CSAT, payload)
}

/** Skip / close without rating — starts 30-day cooldown (null score in DB). */
export async function dismissCsatResponse(payload: CsatWritePayload): Promise<void> {
  if (isImpersonating()) {
    return
  }
  await apiClient.post(API_ENDPOINTS.CSAT, { ...payload, skipped: true })
}
